import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { isMoment, isDate } from 'moment';
import moment from 'moment';
import { UtilsProvider } from "../providers/utils-provider.service";

@Pipe({
  standalone: true,
  name: 'appDate',
})
export class AppDatePipe implements PipeTransform {

    constructor(
        private datePipe: DatePipe,
        private utils: UtilsProvider
    ) { }

    public transform(
        date: string|Date,
        format?: string,
        timezone?: string,
        locale?: string
    ): string|null {
        const item: Date | null = this.getDate(date);

        // Check for invalid date and use today as fallback
        if (item && isNaN(item.getTime())) {
            const fallbackDate = new Date();
            
            // week number is buggy according to : https://github.com/angular/angular/issues/25380
            if (format === 'w') {
                return this.utils.getWeekNumber(fallbackDate, locale) + '';
            }
            
            return this.datePipe.transform(fallbackDate, format, timezone, locale);
        }

        // week number is buggy according to : https://github.com/angular/angular/issues/25380
        if (format === 'w') {
            return item ? this.utils.getWeekNumber(item, locale) + '' : null;
        }

        return item ? this.datePipe.transform(item, format, timezone, locale) : null;
    }

    public getDate(date: string|Date): Date | null {
        if (isDate(date)) {
            return date;
        }

        if (isMoment(date)) {
            return date.toDate();
        }

        if (null === date || '' === date || undefined === date || typeof date !== 'string') {
            return null;
        }

        const m = moment(date);
        if (m.isValid()) {
            return m.toDate();
        }
        return null;
    }
}
